const brands = {
  props: {
    dynamicClass: ".c-brands.dynamicLoading",
    buttonSelector: "button-top-footer-JS",
    brandSelector: "c-brands__brand",
  },

  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-brands.css", this.props.dynamicClass);

    const element = document.getElementsByClassName(this.props.buttonSelector);

    if (!element || !element[0]) {
      return;
    }

    element[0].addEventListener("click", function () {
      bcl.u.goToWithScroll();
    });
    const selector = this.getPageName()[0] !== "#" && this.getPageName()[0] !== "?" ? "." + this.getPageName() : "";
    const url = this.getBrandUrl(selector);
    if (url) {
      bcl.ajax.getRequest(null, url, this.updateBrandsUrl.bind(this));
    }
  },
  getBrandUrl: function (selector) {
    const brands = document.getElementsByClassName(this.props.brandSelector);
    if (brands && brands[0]) {
      return brands[0].parentNode.dataset.resourcePath + ".bcldata" + selector + ".json";
    }
    return "";
  },
  updateBrandsUrl: function (response) {
    const brands = document.getElementsByClassName(this.props.brandSelector);
    if (!brands || !brands[0] || !response) {
      return;
    }
    try {
      const responseBrands = JSON.parse(response.response);
      for (let i = 1; i < brands.length; i++) {
        const url = "url" + i;
        if (Object.prototype.hasOwnProperty.call(responseBrands, url)) {
          const $a = brands[i].getElementsByTagName("a")[0];
          $a.href = responseBrands[url].href;
        }
      }
    } catch (e) {
      console.warn("Error on updateBrandsUrl ", e);
    }
  },
  getPageName: function () {
    let pageName = "";
    const paths = window.location.href.replace("#fixedhotelmap", "").split("/");
    if (paths.length > 1) {
      const pathsNew = bcl.c.brands.removeRedirectTrueParam(paths);
      pageName = pathsNew[pathsNew.length - 1].length > 0 ? pathsNew[pathsNew.length - 1] : pathsNew[pathsNew.length - 2];
      const extIndex = pageName.indexOf(".html");
      if (extIndex > 0) {
        return pageName.slice(0, extIndex);
      }
    }
    return pageName;
  },
  removeRedirectTrueParam: function (paths) {
    const newPathList = [];
    for (let i = 0; i < paths.length; i++) {
      let itemPath = paths[i];
      const paramPos = itemPath.indexOf("?");
      if (paramPos != -1) {
        itemPath = itemPath.substring(0, paramPos);
      }
      newPathList.push(itemPath);
    }
    return newPathList;
  },
};

export default brands;
